export default "__VITE_ASSET__jfSpumP$__"